import { stringify } from 'querystring';
import { getQueryStringParameters } from 'owa-querystring';
import { getWindowData } from 'owa-window-data';

export function redirectToAuthenticatedRoute(): void {
    const queryStringValues = getQueryStringParameters(getWindowData().location);
    delete queryStringValues.anonymous;

    // Delete both to account for different capitalizations.
    delete queryStringValues.isAnonymous;
    delete queryStringValues.isanonymous;

    getWindowData().location.search = '?' + stringify(queryStringValues);
}
